import FavouritesPage from "./FavouritesPage";

export default FavouritesPage;
